<template>
  <div>
    <h3 style="margin-left:30px">基本信息：</h3>
    <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
      单位名称：
      <a-input v-model="name" placeholder="请输入" allowClear style="width:500px" />
    </div>

    <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
      单位编号：
      <a-input v-model="code" placeholder="请输入" allowClear style="width:500px" />
    </div>

    <a-button type="primary" @click="handleSubmit" style="margin-left:120px;margin-top:50px">保存</a-button>
  </div>
</template>

<script>
import request from "../../utils/request";
import Global from "../../global_variable";

export default {
  data() {
    return {
      name: "",
      code: "",
      unit_id: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        request({
          url: "/edc_unit/detail",
          method: "POST",
          params: {
            unit_id: the_id
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.name = data.data.name;
            this.code = data.data.code;
            this.unit_id = the_id;
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      }
    },
    handleSubmit() {
      console.log("看看数据", this.name, this.code);
      if (this.unit_id) {
        request({
          url: "/edc_unit/eic/update",
          method: "POST",
          data: {
            name: this.name,
            code: this.code,
            unit_id :this.unit_id
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success("修改成功");
            this.$router.push({ path: "/unit/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      } else {
        request({
          url: "/edc_unit/eic/add",
          method: "POST",
          data: {
            name: this.name,
            code: this.code
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success("添加成功");
            //   this.form.resetFields();
            //   this.$message.success(data.msg);
            //   this.$router.push({ path: "/project/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      }
    }
  }
};
</script>
